module.exports = __webpack_public_path__ + "static/media/flooring_lcs_10y_n.bad416ba.csv";